import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { useCurrentUser } from '@mews-commander/core';
import { SecurityRestriction } from '../../../components';
import { BackendPage } from './BackendPage';

interface Props {
    url: string;
}

/**
 * This rendres Backend page only if user is secure (logged in with SSO/MFA)
 * @param url
 * @returns JSX.Element
 */
export const SecureBackendPage = ({ url }: Props) => {
    const isFeatureEnabled = useFeatureFlag(FeatureFlag.isSecureLoginPageRestrictionEnabled);
    const { isSecure } = useCurrentUser();

    if (isFeatureEnabled && !isSecure) {
        return <SecurityRestriction />;
    }

    return <BackendPage url={url} />;
};
